import {
  QuestionnaireContextType,
  QuestionnaireHandle,
  QuestionnaireProviderProps,
} from "@/components/questionnaire/questionnaire.types.ts";
import { QuestionnaireContext } from "@/components/questionnaire/questionnaire-context.ts";
import { useQuestionnaire } from "@/components/questionnaire/use-questionnaire.ts";
import { forwardRef, useImperativeHandle } from "react";
import { FormProvider } from "react-hook-form";

export const QuestionnaireProvider = forwardRef<QuestionnaireHandle, QuestionnaireProviderProps>(
  ({ type, id, onAfterSubmit, isAnonymous = false, targetEmployee, children }, ref) => {
    const {
      methods,
      questionnaireForm,
      currentPage,
      totalPages,
      isSaving,
      isSubmitting,
      submitQuestionnaire,
      handleNextPage,
      handlePreviousPage,
      handleSaveDraft,
      questionnaireType,
      errors,
    } = useQuestionnaire(type, id, onAfterSubmit, targetEmployee);

    useImperativeHandle(ref, () => ({
      saveDraft: handleSaveDraft,
    }));

    const contextValue: QuestionnaireContextType = {
      questionnaireId: Number(id),
      currentPage,
      totalPages,
      isLastPage: currentPage === totalPages,
      questionnaireForm,
      errors,
      isSubmitting,
      isSaving,
      isAnonymous,
      nextPage: handleNextPage,
      previousPage: handlePreviousPage,
      submitQuestionnaire: submitQuestionnaire,
      questionnaireType,
      targetEmployee,
    };

    return (
      <QuestionnaireContext.Provider value={contextValue}>
        <FormProvider {...methods}>{children}</FormProvider>
      </QuestionnaireContext.Provider>
    );
  }
);
